import React from 'react';

export class ChartErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorCount: 0 };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error
    console.warn('Chart rendering error caught:', error, errorInfo);

    // Increment error count
    this.setState(prevState => ({
      errorCount: prevState.errorCount + 1
    }));

    // Auto-recover after a short delay
    setTimeout(() => {
      this.setState({ hasError: false });
    }, 100);
  }

  render() {
    if (this.state.hasError) {
      // Show a minimal placeholder during recovery
      return (
        <div className="text-center py-4 text-gray-400 text-sm">
          Loading chart...
        </div>
      );
    }

    return this.props.children;
  }
}
